
import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend
export default {
  
    retrieve (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/userConfigurations`, parameters)
    },

    update (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/userConfigurations`, parameters)
    },

    create (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/userConfigurations/create`, parameters)
    },
}